export const faqIncorporation = [
    {
        question: "What do I need to prepare before I incorporate my business?",
        answer:
            "Two possible names for your company, just in case the company name that you have in mind is already being reserved by another company."
    },
    {
        question:
            "Where can I verify the availability of my preferred company name?",
        answer:
            "You can always click here to visit ICRIS (Integrated Companies Registery Information System) to perform a quick search for your preferred company name."
    },
    {
        question: "What do I put down for commercial address?",
        answer:
            "You can always click here to visit ICRIS (Integrated Companies Registery Information System) to perform a quick search for your preferred company name."
    },
    {
        question:
            "Can I use a overseas address when registering my residential address?",
        answer: "Yes, you can."
    },
    {
        question:
            "What documentations should I prepare before the incorporation?",
        answer:
            "1) A properly and clear scanned copy of your passport or Hong Kong Permanent identification card. 2) Utility bills that was issued to the intend directors and shareholders within the past 3 months"
    },
    {
        question:
            "How long would it take for the incorporation to be effective?",
        answer: "Usually around 2~3 business days."
    }
];
